import React, { useCallback } from 'react';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

// Now just a deactivation modal - no modal required for activation
export const UserDeactivationModal = ({
  error = null,
  user = {},
  onUserUpdated = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const userId = user?.id;
  const userEmail = user?.email || 'user@mail.com';

  const onConfirm = useCallback(() => {
    onUserUpdated(userId, false)
  }, [userId, onUserUpdated])

  return (
    <ConfirmationDialog
      title="Deactive User"
      confirmButtonText="Deactivate"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="deactivate-user-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="w-small-modal flex flex-col p-2 m-1">
        <Label>
          The selected user will no longer have access to Wallaroo unless reactivated. Any record referencing the user will show as <i className="text-md">“{userEmail} (Inactive User).”</i> Are you sure?
        </Label>
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while deactivating the user. Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default UserDeactivationModal;
